import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemDragonConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ItemDragonConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemDragonConfig, v);
            }
        );
    }

    constructor() {
        super();

        this._speed = 1;
        this._power = 0;
        this._capacity = 0;
    }

    get speed() {
        return this._speed;
    }

    set speed(value) {
        this._speed = value;
    }

    get power() {
        return this._power;
    }

    set power(value) {
        this._power = value;
    }

    get capacity() {
        return this._capacity;
    }

    set capacity(value) {
        this._capacity = value;
    }

    valid() {
        if (Number.isNaN(this.speed) || this.speed <= 0) {
            return false;
        }

        if (!Number.isInteger(this.power) || this.power <= 0) {
            return false;
        }

        if (!Number.isInteger(this.capacity) || this.capacity <= 0) {
            return false;
        }

        return true;
    }

    empty() {
        return this.capacity <= 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemDragonConfig());
        } else if (target instanceof ItemDragonConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemDragonConfig, {
    _speed: alias("speed", Schema.primitive()),
    _power: alias("power", Schema.primitive()),
    _capacity: alias("capacity", Schema.primitive())
});